import { ChangeEvent, FC, FormEvent, useState } from "react";
import { useSubscribeToWhitelistMutation } from "store/api/new.api";
import Button from "../button/button";

import styles from "./subscribe-form.module.scss";

interface ISubscribeForm {
  brevoId?: string;
}

const SubscribeForm: FC<ISubscribeForm> = ({ brevoId }) => {
  const [email, setEmail] = useState<string>("");
  const [subscribeToWhitelist, { isLoading }] =
    useSubscribeToWhitelistMutation();

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      await subscribeToWhitelist({
        email,
        listId: brevoId ? +brevoId : 3,
      }).unwrap();
      setEmail("");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={styles.subscribeContainer}>
      <div className={styles.textSection}>
        <p className={styles.title}>Never want to miss the next Alpha IDO?</p>
        <h2 className={styles.subtitle}>
          Sign up for our newsletter and get the latest news and updates
        </h2>
      </div>
      <form onSubmit={handleSubmit} className={styles.form}>
        <input
          type="email"
          placeholder="Email Address*"
          value={email}
          onChange={handleInputChange}
          className={styles.input}
          required
        />
        <Button
          variant="pink"
          type="submit"
          className={styles.button}
          disabled={isLoading}
        >
          {isLoading ? "Subscribing..." : "Subscribe"}
        </Button>
        {/* {isError && <p className={styles.error}>Failed to subscribe. Please try again.</p>}
        {isSuccess && <p className={styles.success}>Successfully subscribed!</p>} */}
      </form>
    </div>
  );
};

export default SubscribeForm;
